export default {
    CHANNEL_TYPE: 3, // 为方便以后区分用户来源，用户侧的接口需要统一加上一个请求参数: 0——服务号、 1——订阅号、2——快应用、 3——表示M站、 4——小程序
    DEV_PASSTOKEN:
        'dsm-hxSRALJzGQdzW9r1cvOvPLgh_05agFe4VsygYy57o1E6m-hoyailByv6ergt-YeTAIP4UvSoBXM7SqrpiS4bmKUVOP4tbjff8Me10HJ_kJx6jXod5bYQOaaEF34g0-GukZw',
};
